import { Geometry } from 'geojson';

export interface OnsiteVisitsResponseDto {
    content: OnsiteVisitDto[];
    last: boolean;
    totalElements: number;
    totalPages: number;
    first: boolean;
    size: number;
    number: number;
    empty: boolean;
}

export interface OnsiteVisitDto {
    id: string;
    externalId: string;
    title: string;
    assignedToEmail: string | null;
    visitDate: Date | null;
    status: string;
    template: OnsiteVisitTemplateDto;
}

export interface OnsiteVisitTemplateDto {
    id: string;
    externalId: string;
    name: string;
    status: string;
}

export interface OnsiteVisitSearchDto {
    page: number;
    size: number;
    status: string | null;
    templateId: string | null;
    sort: string;
    visitDateFrom: string | null;
    visitDateTo: string | null;
}

export enum AnswerType {
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    DROPDOWN = 'DROPDOWN',
    CHECKBOX = 'CHECKBOX',
    DATE_TIME = 'DATE_TIME',
    MULTIPLE_CHOICE = 'MULTIPLE_CHOICE',
    PHOTO = 'PHOTO',
    ANNOTATION = 'ANNOTATION',
    SIGNATURE = 'SIGNATURE',

    ENTITY = 'ENTITY',
    NO_RESPONSE = 'NO_RESPONSE',
    QR_CODE = 'QR_CODE',
    LOCATION = 'LOCATION',
    USER_AUTOMATIC = 'USER_AUTOMATIC',
    DATETIME_AUTOMATIC = 'DATETIME_AUTOMATIC',
}

export interface QuestionConfig {
    required: boolean;
    defaultValue: string | null;
    validation: ValidationRules | null;
    fileTypes: string[] | null;
    placeholder: string | null;
    options: string[] | null;
}

export interface ValidationRules {
    min: number | null;
    max: number | null;
    regex: string | null;
    dateRange: DateRange | null;
}
export interface DateRange {
    from: Date | null;
    to: Date | null;
}

export interface AttachmentDto {
    externalId: string;
    name: string | null;
    appUrl: string;
    gcpUrl: string | null;
    metadata: AttachmentMetadataDto | null;
    isTemporary: boolean;
}

export interface AttachmentMetadataDto {
    type: string | null;
    size: number | null;
    mimeType: string | null;
    height: number | null;
    width: number | null;
    createdAt: string | null;
    updatedAt: string | null;
}

// Polymorphic Form Types
export interface FormQuestionDto {
    type: 'question';
    id: string;
    externalId: string;
    tag: string | null;
    question: string;
    response: string;
    targetEntity: string | null;
    targetField: string | null;
    attachments: AttachmentDto[];
    answerType: AnswerType;
    config: QuestionConfig | null;
}

export interface FormSectionDto {
    type: 'section';
    sectionIdentifier: string;
    targetEntity: string | null;
    instances: FormQuestionDto[][];
}

export type FormItemDto = FormQuestionDto | FormSectionDto;

export interface FormResponseDto {
    items: FormItemDto[];
}

// Polymorphic Submit Types
export interface SubmittedFormQuestionDto {
    type: 'question';
    questionId: string;
    questionTag: string | null;
    targetEntity: string | null;
    targetId: string | null;
    response: string;
    attachments: AttachmentDto[] | null;
    buildingDataProductId: string | null;
}

export interface SectionInstanceDto {
    targetEntity: string | null;
    targetId: string | null;
    buildingDataProductId: string | null;
    questions: SubmittedFormQuestionDto[];
}

export interface SubmittedFormSectionDto {
    type: 'section';
    sectionIdentifier: string;
    instances: SectionInstanceDto[];
}

export type SubmittedFormItemDto = SubmittedFormQuestionDto | SubmittedFormSectionDto;

export interface FormSubmitPayloadDto {
    items: SubmittedFormItemDto[];
}

export interface RequestStatus {
    isLoading: boolean;
    message: string | null;
    type: 'success' | 'error' | null;
}

export interface Building {
    id: string;
    code: string;
    name: string;
    dataProductId: string;
    geometry: Geometry;
}

export interface LocationSearch {
    location: Location;
    radius: number;
}
